// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ucJs","header":"ReportDetails_header__375EO","title":"ReportDetails_title__1X9JW","left":"ReportDetails_left__D25j5"};